import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { settingsKeys } from 'core/query-client/keys/settings.keys';
import { updateQuery } from 'core/query-client/query-client';
import { executeRequest } from 'core/utils/backend-service';
import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { getEapSettingById } from '../eap-settings.service';

export const useFetchEapSetting = (id: string) => {
    const { data: eapSetting = null, isFetching: isLoading } = usePocQuery<EapSettings | null>({
        queryKey: settingsKeys.eapDetail(id),
        queryFn: () => executeRequest(() => getEapSettingById(id)),
        enabled: !!id,
    });

    return { eapSetting, isLoading, refetch: () => updateQuery(settingsKeys.eapDetail(id)) };
};
